import { forwardRef, type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/cn";

const skeletonBaseClassName = "bfrs-relative bfrs-overflow-hidden bfrs-bg-surface-raised";
const animatedShimmerClassName = "before:bfrs-absolute before:bfrs-inset-y-0 before:-bfrs-left-full before:bfrs-w-full before:bfrs-animate-shimmer before:bfrs-bg-gradient-to-r before:bfrs-from-transparent before:bfrs-via-surface-card/70 before:bfrs-to-transparent";
const staticShimmerClassName = "before:bfrs-absolute before:bfrs-inset-y-0 before:bfrs-left-0 before:bfrs-w-full before:bfrs-bg-gradient-to-r before:bfrs-from-transparent before:bfrs-via-surface-card/70 before:bfrs-to-transparent";

const skeletonVariants = cva(skeletonBaseClassName, {
  variants: {
    variant: {
      text: "bfrs-h-4 bfrs-rounded-pill",
      block: "bfrs-h-24 bfrs-rounded-lg",
      card: "bfrs-h-40 bfrs-rounded-xl",
      avatar: "bfrs-size-10 bfrs-rounded-pill"
    }
  },
  defaultVariants: {
    variant: "block"
  }
});

export type SkeletonProps = HTMLAttributes<HTMLDivElement> & VariantProps<typeof skeletonVariants> & {
  animated?: boolean;
};

export const Skeleton = forwardRef<HTMLDivElement, SkeletonProps>(({ animated = true, className, variant, ...props }, ref) => (
  <div ref={ref} aria-hidden="true" className={cn(skeletonVariants({ variant }), animated ? animatedShimmerClassName : staticShimmerClassName, className)} {...props} />
));

Skeleton.displayName = "Skeleton";
